<template>
  <v-container id="roadmap-item-edit" fluid tag="section">
    <v-row justify="center">
      <v-col cols="12" md="12">
        <material-card color="primary" icon="mdi-account-outline">
          <template #title>
            {{ isNewAction ? $t('new_banner') : $t('edit_banner') }}
          </template>
          <v-tabs vertical>
            <v-tab>
              <v-icon left>mdi-account</v-icon>
              {{ $t('general') }}
            </v-tab>
            <v-tab-item>
              <general-tab ref="general_tab" :item="item" />
            </v-tab-item>
          </v-tabs>
          <v-container class="py-0">
            <v-row>
              <v-col cols="12" sm="6" class="text-left">
                <v-btn v-if="!isNewAction" min-width="150" @click="deleteItem">
                  {{ $t('delete') }}
                </v-btn>
              </v-col>
              <v-col cols="12" sm="6" class="text-right">
                <v-btn color="primary" min-width="150" @click="submit">
                  {{ $t('save') }}
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </material-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { mapActions } from 'vuex'
import GeneralTab from '@/components/Settings/Landing/Banners/Edit/Tabs/GeneralTab'
export default {
  name: 'EditBanner',
  components: {
    GeneralTab,
  },
  data: () => ({
    loading: false,
    item: {
      id: null,
      type: 'landing_unique_offer',
      new: false,
      start_date: null,
      end_date: null,
      image: null,
    },
  }),
  async mounted () {
    if (!this.isNewAction) {
      await this.loadItem({ banner_id: this.$route.params.id })
        .then(result => {
          this.item = result.data
        })
    }
  },
  methods: {
    ...mapActions({
      loadItem: 'settings/landing/banners/loadBanner',
      updateItem: 'settings/landing/banners/update',
      removeItem: 'settings/landing/banners/delete',
      createItem: 'settings/landing/banners/create',
    }),
    runItemUpdate () {
      this.$bus.$emit('banner-update-run')
      const form = new FormData()
      form.append('banner_id', this.item.id)
      Object.keys(this.$refs.general_tab.newBannerData).forEach(key => {
        if (key !== 'image') {
          form.append(key, this.$refs.general_tab.newBannerData[key])
        } else if (this.$refs.general_tab.newBannerData[key]) {
          // TODO: This should be replaced with the dropzone
          form.append(key, this.$refs.general_tab.newBannerData[key], this.$refs.general_tab.newBannerData[key].name)
        }
      })
      this.updateItem(form)
    },
    runItemCreate () {
      const form = new FormData()
      Object.keys(this.$refs.general_tab.newBannerData).forEach(key => {
        if (key !== 'image') {
          form.append(key, this.$refs.general_tab.newBannerData[key])
        } else {
          // TODO: This should be replaced with the dropzone
          form.append(key, this.$refs.general_tab.newBannerData[key], this.$refs.general_tab.newBannerData[key].name)
        }
      })
      this.createItem(form)
        .then(result => {
          this.$router.push(`/settings/landing/banners/${result.data.id}`)
        })
    },
    submit () {
      if (this.isNewAction) {
        this.runItemCreate()
      } else {
        this.runItemUpdate()
      }
    },
    deleteItem () {
      this.removeItem({ banner_id: this.item.id })
        .then(() => {
          this.$router.push('/settings/landing/roadmap/')
        })
    },
  },
  computed: {
    isNewAction () {
      return this.$route.params.id === 'new'
    },
  },
}
</script>
